import api from '../Api';

export async function getAssemblies() {
  return api.get('vote');
}

export async function vote(questionId: string, answer: boolean) {
  return api.put(`vote/vote/${questionId}`, {id: questionId, resposta: answer});
}
